class NavService {
  public redirectUser(dest: string) {
    try {
      window.location.replace(dest);
    } catch (e) {
      console.error(e);
    }
  }
}

export default NavService;
